import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faDownload } from '@fortawesome/pro-light-svg-icons'

import { Button } from '@domain-group/suit-theme'

type DownloadButtonParams = {
  links: {
    original_url?: string,
    thumb_url?: string,
  },
}

const DownloadButton = (params: DownloadButtonParams) => {
  const { links } = params

  return (
    <Button
      // @ts-expect-error TS2322
      as="a"
      buttonStyle="secondaryUtility"
      fontSize="14px"
      height="fit-content"
      href={links?.original_url}
      icon={<FontAwesomeIcon icon={faDownload} />}
      marginTop="small"
      padding="10px"
      rel="noopener noreferrer"
      target="_blank"
      width="fit-content"
    >
      Download PDF
    </Button>
  )
}

export default DownloadButton
